<template>
  <div>
    <label
      class="grey--text text--darken-4 text-body-2 font-weight-medium"
      :for="label"
      v-html="title"
    />

    <v-text-field
      @input="formatArea"
      :value="displayValue"
      v-bind="$attrs"
      ref="field"
      class="text-body-2 font-weight-regular rounded-lg mt-1 form-control"
      :prefix="monetary ? 'R$ ' : ''"
      hide-details
      :id="label"
      outlined
      dense
    />
  </div>
</template>

<script>
export default {
  props: {
    value: [Number, String],
    title: String,
    monetary: Boolean,
    area: Boolean,
  },
  data: () => ({
    label: "",
    displayValue: "",
  }),
  methods: {
    formatArea(value) {
      if (!this.area && !this.monetary) {
        this.displayValue = value;
        this.$emit("input", value);
        return;
      }

      value = String(value || "");

      const onlyNumbers = value.replace(/\D/g, "");
      if (!onlyNumbers.length) {
        this.displayValue = "";
        this.$emit("input", null);
        return;
      }

      const number = Number(onlyNumbers) / 100;
      if (isNaN(number)) return;

      const val = number.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      this.displayValue = val;
      this.$emit("input", val);
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        if (value === null || value === undefined || value === "") {
          this.displayValue = "";
          return;
        }

        if (this.area || this.monetary) {
          const number = Number(value);
          if (isNaN(number)) return;

          const val = number.toLocaleString("pt-BR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });

          this.displayValue = val;
          this.$emit("input", val);
        } else {
          this.displayValue = value;
        }
      },
    },
  },
  created() {
    if (this.title)
      this.label = this.title
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-zA-Z\s]/g, "")
        .trim()
        .replace(/\s+/g, "-")
        .toLowerCase();
  },
};
</script>
